import { addDays } from 'date-fns';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';

export const MinDeliveryDate = () => {
    const [minDate, setMinDay] = useState(0);
    const currentDate = dayjs().toDate();
    const currentDay = currentDate.getDay();

    // Call getMinDay once on component build
    useEffect(() => {
        GetMinDay(currentDay, setMinDay);
    }, [currentDay]);

    return minDate;
};

// 'getMinDay' calculates the first available delivery date
export const GetMinDay = (crtDay: number, setMinDay: any) => {
    setMinDay(0);
};

// calculates the first available delivery date
export const getMinDeliveryDate = (pickedDate: Date = dayjs().toDate()) => {
    return 0;
};

// 'isWeekday' filters Saturday, Sunday and Monday from the week array for further processing
export const isWeekday = (date: Date, nonWorkingDays: number[] = [0, 1, 6]) => {
    const day = date.getDay();
    return !nonWorkingDays.includes(day);
};

export const getNextWorkingDay = (date: Date) => {
    const day = date.getDay();
    if (day === 0) {
        return addDays(date, 1);
    }
    if (day === 6) {
        return addDays(date, 2);
    }
    return date;
};